<template>
  <a-locale-provider :locale="locale">
    <div id="app" style="height: 100%; width: 100%;">
      <router-view></router-view>
    </div>
  </a-locale-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import enUS from 'ant-design-vue/lib/locale-provider/en_US';

export default {
  name: 'App',
  computed: {
    locale() {
      return this.$store.getters.lang.lang === 'en-US' ? enUS : zhCN
    }
  }
}
</script>
